import { render, staticRenderFns } from "./UpdateResultModal.vue?vue&type=template&id=272bfec4&scoped=true&"
import script from "./UpdateResultModal.vue?vue&type=script&lang=js&"
export * from "./UpdateResultModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateResultModal.vue?vue&type=style&index=0&id=272bfec4&lang=scss&scoped=true&"
import style1 from "./UpdateResultModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272bfec4",
  null
  
)

export default component.exports